import { Article } from './types';
import { powerGenerationArticles } from './content/power-generation';
import { renewableEnergyArticles } from './content/renewable-energy';
import { oilAndGasArticles } from './content/oil-and-gas';
import { newPriorityArticles } from './content/new-priority-articles';
import { solarInverterErrorCodesGuide } from './content/solar-inverter-error-codes-guide';
import { solarInverterCost2026 } from './content/solar-inverter-cost-2026';
import { nercTariffBandsExplained } from './content/nerc-tariff-bands-explained';
import { petrolVsCngGenerators } from './content/petrol-vs-cng-generators';
import { applyPrepaidMeters2026 } from './content/apply-prepaid-meters-2026';
import { nationalGridCollapseCauses } from './content/national-grid-collapse-causes';
import { top10SolarInstallers2026 } from './content/top-10-solar-installers-2026';
import { guideMiniGridsOffGrid } from './content/guide-mini-grids-off-grid';
import { solarSubsidiesGrants } from './content/solar-subsidies-grants';
import { calculateElectricityConsumption } from './content/calculate-electricity-consumption';
import { nigeriaEnergyFuture2026 } from './content/nigeria-energy-future-2026';
import { electricityBillingDisputeResolution } from './content/electricity-billing-dispute-resolution';
import { nercNetBillingRegulations2026 } from './content/nerc-net-billing-regulations-2026';
import { freePrepaidMeterMafDisrep2026 } from './content/free-prepaid-meter-maf-disrep-2026';
import { rainySeasonSolarOptimisation2026 } from './content/rainy-season-solar-panel-battery-optimisation-nigeria';
import { nercEstimatedBillingCappingOrderRefundGuide } from './content/nerc-estimated-billing-capping-order-refund-guide';
import { prepaidMeterAcceptedNoElectricity2026 } from './content/prepaid-meter-accepted-no-electricity-2026';
import { prepaidMeterUnitsFinishFastNigeria2026 } from './content/prepaid-meter-units-finish-fast-nigeria-2026';
import { prepaidMeterMapRefundNigeria } from './content/prepaid-meter-map-refund-nigeria';
import { solarBatteryNotChargingFullyNigeria } from './content/solar-battery-not-charging-fully-nigeria';

// Re-export the type for consumers
export type { Article } from './types';

// Combine all articles into a single source of truth
// New priority articles added first for prominence in listings
export const articles: Article[] = [
    prepaidMeterMapRefundNigeria,
    solarBatteryNotChargingFullyNigeria,
    prepaidMeterUnitsFinishFastNigeria2026,
    prepaidMeterAcceptedNoElectricity2026,
    nercEstimatedBillingCappingOrderRefundGuide,
    rainySeasonSolarOptimisation2026,
    nercNetBillingRegulations2026,
    freePrepaidMeterMafDisrep2026,
    solarInverterErrorCodesGuide,
    ...newPriorityArticles,
    solarInverterCost2026,
    nercTariffBandsExplained,
    petrolVsCngGenerators,
    applyPrepaidMeters2026,
    nationalGridCollapseCauses,
    electricityBillingDisputeResolution,
    top10SolarInstallers2026,
    guideMiniGridsOffGrid,
    solarSubsidiesGrants,
    calculateElectricityConsumption,
    nigeriaEnergyFuture2026,
    ...powerGenerationArticles,
    ...renewableEnergyArticles,
    ...oilAndGasArticles
].filter((article) => ![
    'prepaid-meter-application-guide',
].includes(article.id));
